import React from "react";
import ContentLoader from "react-content-loader";

export default function LoaderDetailAnnonce(props) {
  // Desktop first, responsive via width="100%"
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={620}
      viewBox="0 0 1100 620"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      {/* Breadcrumb */}
      <rect x="0" y="10" rx="6" ry="6" width="260" height="18" />

      {/* LEFT: media */}
      <rect x="0" y="50" rx="14" ry="14" width="520" height="380" />
      <rect x="540" y="50" rx="14" ry="14" width="260" height="182" />
      <rect x="540" y="248" rx="14" ry="14" width="260" height="182" />

      {/* LEFT: title/price/city/date */}
      <rect x="0" y="455" rx="8" ry="8" width="420" height="26" />
      <rect x="0" y="492" rx="8" ry="8" width="220" height="22" />
      <rect x="0" y="526" rx="8" ry="8" width="320" height="18" />
      <rect x="0" y="552" rx="8" ry="8" width="260" height="18" />

      {/* LEFT: info block title + rows */}
      <rect x="0" y="585" rx="8" ry="8" width="240" height="20" />

      {/* RIGHT: seller card */}
      <rect x="820" y="50" rx="16" ry="16" width="280" height="240" />
      {/* avatar */}
      <circle cx="860" cy="95" r="28" />
      {/* name / meta */}
      <rect x="900" y="78" rx="6" ry="6" width="160" height="18" />
      <rect x="900" y="105" rx="6" ry="6" width="120" height="14" />
      {/* buttons */}
      <rect x="840" y="145" rx="20" ry="20" width="240" height="40" />
      <rect x="840" y="198" rx="20" ry="20" width="240" height="40" />
    </ContentLoader>
  );
}
